import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BodyM, LabelL } from '@sorare/core/src/atoms/typography';
import { ConfirmDialog } from '@sorare/core/src/components/form/ConfirmDialog';
import { glossary } from '@sorare/core/src/lib/glossary';

const Body = styled.div`
  padding: 0 var(--double-unit);
`;

type Props = { open?: boolean; onConfirm: () => void; onClose: () => void };
export const ClaimRewardConfirmDialog = ({
  open,
  onConfirm,
  onClose,
}: Props) => {
  return (
    <ConfirmDialog
      open={!!open}
      onConfirm={onConfirm}
      onClose={onClose}
      title={
        <LabelL bold>
          <FormattedMessage defaultMessage="Claim all rewards?" />
        </LabelL>
      }
      message={
        <Body>
          <BodyM className="text-center">
            <FormattedMessage defaultMessage="You haven’t revealed all your rewards. If you continue, they’ll be automatically claimed for you." />
          </BodyM>
        </Body>
      }
      cancelCta={<FormattedMessage {...glossary.cancel} />}
    />
  );
};
